module.exports = __webpack_public_path__ + "img/proyectos.21a71865.svg";